import { Done, Edit } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import React from 'react';

interface TodoActionsProps {
    isEditing: boolean;
    onEdit: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const TodoActions: React.FC<TodoActionsProps> = ({
    isEditing,
    onEdit,
}) => {
    return (
        <Box
            className="action-buttons"
            sx={{
                display: 'flex',
                my: 'auto',
                gap: 0.5,
                opacity: isEditing ? 1 : { xs: 1, sm: 0 },
                transition: 'opacity 0.2s ease',
            }}
        >
            <IconButton
                size="small"
                onClick={(e) => {
                    onEdit(e);
                }}
                sx={{
                    color: isEditing ? 'success.main' : 'primary.main',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        backgroundColor: isEditing ? 'success.light' : 'primary.main',
                        color: 'white',
                        transform: 'scale(1.1)',
                    }
                }}
            >
                {isEditing ? <Done /> : <Edit />}
            </IconButton>
        </Box>
    );
};

export default TodoActions; 